import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ShieldX } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Acceso Denegado - Global Therapy Hub</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-blue-50 to-brand-cream-100 p-4">
        <Card className="max-w-md w-full">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <ShieldX className="h-16 w-16 text-destructive" />
            </div>
            <CardTitle className="text-2xl">Acceso Denegado</CardTitle>
            <CardDescription>
              No tienes permisos para acceder a esta sección
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-center text-sm text-muted-foreground">
              Si crees que esto es un error, por favor contacta con el administrador.
            </p>
            <div className="flex flex-col gap-2">
              <Button onClick={() => navigate('/')} className="w-full">
                Volver al Inicio
              </Button>
              <Button onClick={() => navigate('/auth/login')} variant="outline" className="w-full">
                Iniciar Sesión
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default Unauthorized;
